// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
Vue.config.productionTip = false;
import silder from "@/components/common/silder/SidebarItem.vue";
Vue.component("SidebarItem", silder);
// echarts图标
import echarts from "echarts";
import china from "echarts/map/json/china.json"; // 引入json文件
echarts.registerMap("china", china); // 在echarts中注册使用这个文件
Vue.prototype.$echarts = echarts;
//请求
import axios from "./common/http.js";
Vue.prototype.$http = axios;
import axios2 from "./common/http2.js";
import localAxios from "./common/localhttp.js";
Vue.prototype.$http2 = axios2;
Vue.prototype.$localhttp = localAxios;
Vue.prototype.$req = axios2.$req;

// Vue.prototype.siteBaseUrl = "https://www.zhuoyuyun.com/";
Vue.prototype.siteBaseUrl = "https://www.zhuoyuyun.com/";
// Vue.prototype.loginIndexUrl = "https://login.zhuoyuyun.com/"; //login用户端基础数据接口
Vue.prototype.loginIndexUrl = "https://login.zhuoyuyun.com/";
// ui框架
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
Vue.use(Element);
import { message } from "@/common/restMessage.js";
Vue.prototype.$message = message;
//页面转odf
import htmlToPdf from "@/common/htmlToPdf.js";
Vue.use(htmlToPdf);
//弹幕效果
import { vueBaberrage } from "vue-baberrage";
Vue.use(vueBaberrage);
// 一些方法
import comm from "@/common/comme.js";
Vue.prototype.$fun = comm;
Vue.prototype.$this = this;
var _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?f9768ac2532868f3b07a5bb99006cb68";
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);
// })();
// 注册一个全局自定义指令 `v-focus`
Vue.directive("focus", {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function(el) {
    // 聚焦元素
    el.focus();
    // element-ui
    el.children[0].focus();
    // 元素有变化，如show或者父元素变化可以加延时或判断
    setTimeout(_ => {
      el.children[0].focus();
    });
  }
});

import katex from "katex";
// !import 不能忘记引入katex的样式
import "katex/dist/katex.css";
// 引入katex下的自动渲染函数
import renderMathInElement from "katex/contrib/auto-render/auto-render";

// 定义自动渲染的配置参数,这些参数根据你的需求进行修改，下面的参数是官网上抄下来的
const renderOption = {
  delimiters: [
    { left: "$$", right: "$$", display: true },
    { left: "$", right: "$", display: false },
    { left: "\\(", right: "\\)", display: false },
    { left: "\\[", right: "\\]", display: true }
  ],
  throwOnError: false
};

// 挂载自动渲染函数到vue原型
Vue.prototype.$formula = function(dom) {
  renderMathInElement(dom, renderOption);
};

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js